// src/components/Gallery/PaintingsLayout.js
import React from 'react';
import { PaintingMediaComponent } from './MediaComponents';
import CategorySeparator from './CategorySeparator';

const PaintingsLayout = ({ sections, onImageClick }) => {
  return (
    <div className="portfolio-paintings-layout">
      <div className="portfolio-paintings-grid">
        {sections.map((item, index) => {
          if (item.type === 'category') {
            return (
              <CategorySeparator 
                key={`category-${index}`} 
                category={item} 
              />
            );
          }
          
          // Regular artwork rendering
          const itemClass = `portfolio-painting-item ${item.layout || 'default'}`;
          
          return (
            <div key={item.id} className={itemClass}>
              <PaintingMediaComponent 
                item={item}
                onClick={() => onImageClick(item)}
              />
              <div className="portfolio-painting-title">
                {item.title}, {item.year}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PaintingsLayout;